// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3SBgk","Breadcrumb":"Layout_Breadcrumb__TH6JN"};